.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--white);
  padding: 3rem 1.5rem 5rem 1.5rem;
  border-radius: 0 0 8px 8px;
}

.input {
  width: 275px;
}

.error {
  color: var(--danger);
  padding-bottom: 1.5rem;
}
